<template>
  <div class="content-box col-8" style="padding-right: 0px">
    <div class="row element-box" style="padding-right: 0px">
      <div class="col-12 row">
        <div class="col-12">
          <div class="col-12">
            <div>
              <router-link class="btn btn-sm btn-outline-dark" :to="{ name: 'cxp-cargo', params: {} }">
                <i class="fas fa-angle-double-left"></i>
                Regresar
              </router-link>
              <!-- aqui se empieza el menu de opciones  -->
              <div class="st-meta float-right">
                <div class="element-actions">
                  <div class="btn-group">
                    <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                      data-toggle="dropdown" type="button">
                      <i class="fa fa-cogs"></i>
                      Acciones
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button class="dropdown-item" :class="{ disabled: !(current.estado == 'B') }" @click="abrir"
                        :disabled="!(current.estado == 'B')" href="#">
                        <i class="fa fa-unlock"></i>
                        Abrir Operación
                      </button>
                      <button class="dropdown-item" @click="cerrar" :disabled="!(current.estado == 'A')" href="#">
                        <i class="fa fa-lock"></i>
                        Cerrar Operación
                      </button>
                      <button class="dropdown-item" @click="Imprimir_cxpcargo()" :disabled="!(current.estado == 'B')">
                        <i class="fas fa-print"></i>
                        Imprimir Reporte
                      </button>
                      <button class="dropdown-item" @click="anular()" :disabled="!(current.estado != '9')" href="#">
                        <i class="fas fa-archive"></i>
                        Anular Operación
                      </button>
                      <button class="dropdown-item" :class="{ disabled: !(current.estado == 'A') }"
                        @click="generarAutoContabilizacion()" :disabled="!(current.estado == 'A')" href="#">
                        <i class="fa fa-sync"></i>
                        Generar <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;Auto. contabilización
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- fin de menú de opciones  -->
            </div>
            <br>
            <div>
              <div class="row">
                <div class="col-8">
                  <span style="font-size: 22px"><b>CXP Cargo</b></span>
                  <span style="font-size: 22px"><b> #{{ current.numero }}</b></span>
                </div>
              </div>
            </div>
            <br>
          </div>
          <table class="table">
            <tbody>
              <tr>
                <td style="border-top: 0">
                  <label>Fecha Documento</label>
                  <input :format="'dd/MM/yyyy'" class="form-control form-control-sm" :disabled="current.estado != 'A'"
                    type="date" v-bind:class="{
                      'is-invalid':
                        current.errors.fecha_documento &&
                        current.errors.fecha_documento.length > 0,
                    }" v-model="current.fecha_documento" />
                  <small v-if="current.errors && current.errors.fecha_documento" class="form-text text-danger">{{
                    current.errors.fecha_documento[0] }}</small>
                </td>
                <td style="border-top: 0">
                  <label>Fecha Vencimiento</label>
                  <input type="date" :format="'dd/MM/yyyy'" class="form-control form-control-sm"
                    :disabled="current.estado != 'A'" v-bind:class="{
                      'is-invalid':
                        current.errors.fecha_vencimiento &&
                        current.errors.fecha_vencimiento.length > 0,
                    }" v-model="current.fecha_vencimiento" />
                  <small v-if="current.errors && current.errors.fecha_vencimiento" class="form-text text-danger">{{
                    current.errors.fecha_vencimiento[0] }}</small>
                </td>
                <td style="border-top: 0">
                  <label>Fecha Pago</label>
                  <input type="date" :format="'dd/MM/yyyy'" class="form-control form-control-sm"
                    :disabled="current.estado != 'A'" v-bind:class="{
                      'is-invalid':
                        current.errors.fecha_pago && current.errors.fecha_pago.length > 0,
                    }" v-model="current.fecha_pago" />
                  <small v-if="current.errors && current.errors.fecha_pago" class="form-text text-danger">{{
                    current.errors.fecha_pago[0] }}</small>
                </td>
                <td style="border-top: 0">
                  <label>Fecha IVA</label>
                  <input type="date" :format="'dd/MM/yyyy'" class="form-control form-control-sm"
                    :disabled="current.estado != 'A'" v-bind:class="{
                      'is-invalid':
                        current.errors.fecha_iva && current.errors.fecha_iva.length > 0,
                    }" v-model="current.fecha_iva" />
                  <small v-if="current.errors && current.errors.fecha_iva" class="form-text text-danger">{{
                    current.errors.fecha_iva[0] }}</small>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <div class="col-12" style="padding-left: 0%">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="col col-sm-3 nav-item nav-link active text-center" id="nav-home-tab" data-toggle="tab"
                  href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">
                  Facts de Compras</a>
                <a class="col col-sm-2 nav-item nav-link text-center" id="barras-tab" data-toggle="tab"
                  href="#cuentasContable" role="tab" aria-controls="nav-profile" aria-selected="false">Contabilización</a>
                <a class="col col-sm-2 nav-item nav-link text-center" id="barras-tab" data-toggle="tab"
                  href="#retenciones" role="tab" aria-controls="nav-profile" aria-selected="false">Retenciones</a>
                <a class="col col-sm-3 nav-item nav-link text-center" id="barras-tab" data-toggle="tab" href="#abonos"
                  role="tab" aria-controls="nav-profile" aria-selected="false">Info. de pagos</a>
              </div>
            </nav>
            <div style="padding-left: 0px" class="tab-content element-box" id="nav-tabContent">
              <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <div class="row">
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <h6 class="text-success">Facturas en Cargo</h6>
                  <div class="col-10">
                    <button :disabled="!current.id || current.estado != 'A'" data-target="#modalentradas"
                      data-toggle="modal" href="#" class="btn btn-md btn-primary">
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                </div>
                <br>
                <div class="element-box-tp">
                  <div class="table-responsive">
                    <table class="table table-lightborderr">
                      <thead>
                        <tr>
                          <th class="text-left" style="width: 60px">SERIE</th>
                          <th class="text-left" style="width: 60px">NÚMERO</th>
                          <th class="text-left" style="width: 100px">FECHA DOCUMENTO</th>
                          <th class="text-left" style="width: 100px">FECHA CREACIÓN</th>
                          <th class="text-left" style="width: 60px">TIPO</th>
                          <th class="text-right" style="width:100px">MONTO</th>
                          <th class="text-left" style="width: 100px">CENTRO COSTO</th>
                          <th class="text-right" style="width:10px"></th>
                          <th v-if="current.estado == 'A'" class="text-right" style="width: 10px"></th>
                        </tr>
                      </thead>
                      <tbody v-for="(detalle, index) in current.cargod_set" :key="detalle.id">
                        <tr>
                          <td @click="mostrarDetalle(index, detalle)" style="animation: fade-in 1.5s 1" v-bind:style="detalle_ == detalle || detalle == detalle_facts_service
                            ? 'background-color: #B9D6A3;'
                            : 'background-color: white;'
                            " class="text-left bolder nowrap">
                            <span class="text-dark" style="font-size: 85%">{{
                              detalle.serie
                            }}</span>
                          </td>
                          <td @click="mostrarDetalle(index, detalle)" style="animation: fade-in 1.5s 1" v-bind:style="detalle_ == detalle || detalle == detalle_facts_service
                                ? 'background-color: #B9D6A3;'
                                : 'background-color: white;'
                              " class="text-left bolder nowrap">
                            <span class="text-dark" style="font-size: 85%">{{
                              detalle.documento
                            }}</span>
                          </td>
                          <td @click="mostrarDetalle(index, detalle)" v-bind:style="detalle_ == detalle || detalle == detalle_facts_service
                                ? 'background-color: #B9D6A3;'
                                : 'background-color: white;'
                              " style="width: 150px; animation: fade-in 1.5s 1" class="text-left">
                            <span>{{ detalle.fecha_documento }}</span>
                          </td>
                          <td @click="mostrarDetalle(index, detalle)" v-bind:style="detalle_ == detalle || detalle == detalle_facts_service
                            ? 'background-color: #B9D6A3;'
                            : 'background-color: white;'
                            " style="width: 200px; animation: fade-in 1.5s 1" class="text-left">
                            <span>{{
                              detalle.fecha_creacion | moment("DD/MM/YYYY HH:mm")
                            }}
                              Hrs.</span>
                          </td>
                          <td @click="mostrarDetalle(index, detalle)" v-bind:style="detalle_ == detalle || detalle == detalle_facts_service
                                ? 'background-color: #B9D6A3;'
                                : 'background-color: white;'
                              " style="animation: fade-in 1.5s; color: green">
                            {{ detalle.bien_servicio_str }}
                            <br />
                            {{ detalle.local_importado_str }}
                          </td>
                          <td @click="mostrarDetalle(index, detalle)" v-bind:style="detalle_ == detalle || detalle == detalle_facts_service
                            ? 'background-color: #B9D6A3;'
                            : 'background-color: white;'
                            " style="animation: fade-in 1.5s 1" class="text-right bolder nowrap">
                            <span class="text-dark" style="font-size: 85%">
                              Q. {{ detalle.valor_total }}</span>
                          </td>
                          <td @click="mostrarDetalle(index, detalle)" style="animation: fade-in 1.5s 1" v-bind:style="detalle_ == detalle || detalle == detalle_facts_service
                            ? 'background-color: #B9D6A3;'
                            : 'background-color: white;'
                            " class="text-left bolder nowrap">
                            <span v-if="detalle.centro_costo" class="text-dark" style="font-size: 85%; width: 100px">{{
                              detalle.centro_costo.nombre }}</span>
                          </td>
                          <td @click="mostrarDetalle(index, detalle)" v-bind:style="detalle_ == detalle || detalle == detalle_facts_service
                            ? 'background-color: #B9D6A3;'
                            : 'background-color: white;'
                            ">
                            <i v-if="detalle_ == detalle || detalle_facts_service == detalle
                              " class="fas fa-chevron-up"></i>
                            <i v-else class="fas fa-chevron-down"></i>
                          </td>
                          <td v-if="current.estado == 'A'">
                            <div class="dropdown show">
                              <a class="btn btn-link dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-cog"></i>
                              </a>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                <a v-if="current.estado == 'A'" :disabled="!(current.estado == 'A')"
                                  class="dropdown-item text-danger" @click="eliminarFacturaServicio(detalle)">
                                  <i class="fas fa-trash"></i>&nbsp;Eliminar</a>
                                <a v-if="current.estado == 'A'" class="dropdown-item" href="#"
                                  @click="modificarFacturas(detalle)"><i class="fas fa-edit"></i>&nbsp;Modificar
                                  Detalle</a>
                                <a v-if="current.estado == 'A'" class="dropdown-item" href="#"
                                  @click="AbrirModalretenciones(detalle)"><i
                                    class="fas fa-hand-holding-usd"></i>&nbsp;Generar
                                  Retención</a>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="detalle_ == detalle">
                          <td colspan="7">
                            <table style="animation: fade-in 1.5s 1" class="table">
                              <thead>
                                <tr>
                                  <th class="text-center text-success" style="width: 100px">
                                    PRODUCTO
                                  </th>
                                  <th class="text-center text-success">CANTIDAD</th>
                                  <th class="text-center text-success">PRECIO</th>
                                  <th class="text-center text-success">TOTAL LINEA</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="cargodproducto in detalle.cargodproducto_set" :key="cargodproducto.id"
                                  style="height: 10px">
                                  <td class="bolder nowrap">
                                    <span class="text-dark" style="font-size: 85%"><span style="color: blue">{{
                                      cargodproducto.producto }} -</span>
                                      {{ cargodproducto.producto_obj.nombre }}</span>
                                  </td>
                                  <td class="text-center bolder nowrap">
                                    <span class="text-dark" style="font-size: 85%">{{
                                      cargodproducto.cantidad
                                    }}</span>
                                  </td>
                                  <td class="text-center bolder nowrap">
                                    <span class="text-dark" style="font-size: 85%">
                                      Q. {{ cargodproducto.precio }}</span>
                                  </td>
                                  <td class="text-right bolder nowrap">
                                    <span class="text-dark" style="font-size: 85%">
                                      Q {{ cargodproducto.total_linea }}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr v-if="detalle_facts_service == detalle">
                          <td colspan="7">
                            <table style="animation: fade-in 1.5s 1" class="table">
                              <thead>
                                <tr>
                                  <th class="text-center text-success" style="width: 100px">
                                    Descripción de factura
                                  </th>
                                </tr>
                              </thead>
                              <tbody class="text-left">
                                <td>
                                  <span class="font-weight-bold">{{
                                    detalle.observaciones
                                  }}</span>
                                </td>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <hr />
                    <div style="display: flex; justify-content: flex-end">
                      <table>
                        <tr style="background-color: #b9d6a3">
                          <td colspan="1" class="text-center">
                            <h6 style="font-size: 17px" class="text-dark">
                              TOTAL CARGO:
                            </h6>
                          </td>
                          <td colspan="1" class="text-right">
                            <h6 style="font-size: 17px" class="font-weight-bold text-dark">
                              Q{{ current.total }}
                            </h6>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div v-if="!current.resumen_subcategoria" class="element-box-tp">
                  <h6 class="text-success">Total por categoría</h6>
                  <br />
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th class="text-center">CATEGORÍA</th>
                          <th class="text-right">VALOR NETO</th>
                          <th class="text-right">IMPUESTO</th>
                          <th class="text-right">MONTO TOTAL</th>
                        </tr>
                      </thead>
                      <tbody v-for="detalle in current.resumen_subcategoria" :key="detalle.id">
                        <tr>
                          <td class="text-center">
                            <span style="color: green">{{
                              detalle.producto__categoria
                            }}</span>
                            - {{ detalle.producto__categoria__nombre }}
                          </td>
                          <td class="text-right">
                            Q {{ (detalle.total.toFixed(2) / 1.12).toFixed(2) }}
                          </td>
                          <td class="text-right">
                            Q
                            {{ ((detalle.total.toFixed(2) / 1.12) * 0.12).toFixed(2) }}
                          </td>
                          <td style="color: blue" class="text-right">
                            Q {{ detalle.total.toFixed(2) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="cuentasContable" role="tabpanel" aria-labelledby="barras-tab">
                <div>
                  <div class="row">
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <h6 class="text-success">Lista de Contabilización</h6>
                    <div class="col-2">
                      <button :disabled="!current.id || current.estado != 'A'" data-target="#AggModalPolizaContable"
                        data-toggle="modal" href="#" class="btn btn-md btn-primary">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <br />
                    <!-------------------- Tabla de Resultados -------------------->
                    <table class="table table-lightborder">
                      <thead>
                        <tr>
                          <th class="text-left">Cuenta Contable</th>
                          <th class="text-left">Centro Costo</th>
                          <th class="text-left">Fecha</th>
                          <th class="text-right">Cargo</th>
                          <th class="text-right">Abono</th>
                          <th class="text-center">Opciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="detalle in current.cargocontab_set" v-bind:key="detalle.id">
                          <td class="text-left">
                            {{ detalle.cuenta_contable.id }} -
                            {{ detalle.cuenta_contable.nombre }}
                          </td>
                          <td v-if="detalle.centro_costo && detalle.centro_costo.id" class="text-left">
                            {{ detalle.centro_costo.id }} -
                            {{ detalle.centro_costo.nombre }}
                          </td>
                          <td class="text-left">{{ detalle.fecha }}</td>
                          <td class="text-right">Q{{ detalle.cargo }}</td>
                          <td class="text-right">Q{{ detalle.abono }}</td>
                          <td class="text-center">
                            <button :disabled="current.estado != 'A'" @click="eliminarContabilicacion(detalle)"
                              class="btn btn-sm btn-danger">
                              <i class="fa fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot style="background-color: #454545" class="text-light">
                        <tr>
                          <td class="font-weight-bold" colspan="3">
                            <h6 style="font-size: 13px" class="text-light">TOTALES</h6>
                          </td>
                          <td class="text-right">
                            <span style="font-size: 13px" class="font-weight-bold">Q{{ current.total_contab_cargo
                            }}</span>
                          </td>
                          <td class="text-right font-weight-bold">
                            <span style="font-size: 13px">Q{{ current.total_contab_abono }}</span>
                          </td>
                          <td colspan="4"></td>
                        </tr>
                      </tfoot>
                    </table>
                    <!-------------------- END - Basic Table -------------------->
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="retenciones" role="tabpanel" aria-labelledby="barras-tab">
                <div>
                  <div class="row">
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <h6 class="text-success">Resumen de Retenciones Aplicadas</h6>
                  </div>
                  <div class="table-responsive">
                    <br />
                    <!-------------------- Tabla de REsultados -------------------->
                    <table class="table table-lightborder">
                      <thead>
                        <tr>
                          <th class="text-left">Tipo impuesto</th>
                          <th class="text-left">Constancia Ret.</th>
                          <th class="text-left">Cuenta Contable Afecta</th>
                          <th class="text-left">Fecha retención</th>
                          <th class="text-center">Tasa (%)</th>
                          <th class="text-center">Total Retención</th>
                          <th class="text-center">Opciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="detalle in current.cargodretencion_set" v-bind:key="detalle.id">
                          <td class="text-left">
                            {{ detalle.tipo_impuesto }}
                          </td>
                          <td class="text-left">{{ detalle.constancia }}</td>
                          <td class="text-left">
                            {{ detalle.cuenta_contable.id }} -
                            {{ detalle.cuenta_contable.nombre }}
                          </td>
                          <td class="text-left">
                            {{ detalle.fecha_retencion }}
                          </td>
                          <td class="text-center">{{ detalle.porc_ret }}%</td>
                          <td class="text-right">Q {{ detalle.total_ret }}</td>
                          <td class="text-center">
                            <button :disabled="current.estado != 'A'" @click="eliminarRetencion(detalle)"
                              class="btn btn-sm btn-danger">
                              <i class="fa fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot style="background-color: #454545" class="text-light">
                        <tr>
                          <td class="font-weight-bold" colspan="4">
                            <h6 style="font-size: 13px" class="text-light">
                              TOTAL RETENIDO EN CARGO
                            </h6>
                          </td>
                          <td colspan="1"></td>
                          <td class="text-right font-weight-bold">
                            <span style="font-size: 13px">Q {{ current.total_retencion }}</span>
                          </td>
                          <td colspan="1"></td>
                        </tr>
                      </tfoot>
                    </table>
                    <!-------------------- END - Basic Table -------------------->
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="abonos" role="tabpanel" aria-labelledby="barras-tab">
                <div class="row">
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <h6 class="text-success">Resumen Abonos Agregados</h6>
                  <div class="col-2">
                    <button :disabled="!current.id || current.estado != 'A'" data-target="#modalAggPagos"
                      data-toggle="modal" href="#" class="btn btn-md btn-primary">
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                </div>
                <AggPagoPorCargoComponent :current="current" :abonos="abonos" :tipos_abonos="tipos_abonos"
                  @refreshCargo="refreshCurrent()">:</AggPagoPorCargoComponent>
                <br />

                <table class="table table-sm table-striped">
                  <thead>
                    <th class="text-left">Tipo</th>
                    <th class="text-right">Abonado</th>
                    <th class="text-center"># abono</th>
                    <th class="text-center">Estado abono</th>
                    <th class="text-right">Disponible en abono</th>
                    <th class="text-center">Fecha de abono</th>
                    <th class="text-center"></th>
                  </thead>
                  <tbody v-for="abono in current.aplicacionabonocargo_set" v-bind:key="abono.id">
                    <tr v-bind:style="detail == abono
                      ? 'background-color: #B9D6A3;'
                      : 'background-color: white;'
                      ">
                      <td class="text-left">{{ abono.abono_e.tipo_abono }}</td>
                      <td class="text-right">{{ abono.valor_total }}</td>
                      <td class="text-center">
                        {{ abono.abono_e.documento }}
                      </td>
                      <td class="text-center">
                        {{ abono.abono_e.estado_str }}
                      </td>
                      <td class="text-right">
                        {{ abono.abono_e.total_pendiente }}
                      </td>
                      <td class="text-center">
                        {{ abono.abono_e.fecha_documento }}
                      </td>
                      <td class="text-center">
                        <div class="dropdown show">
                          <a class="btn btn-info dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-cog"></i>
                          </a>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <a v-if="current.estado == 'A'" class="dropdown-item text-danger"
                              @click="eliminarAbonoACargo(abono)">
                              <i class="fas fa-trash"></i>&nbsp;Eliminar</a>
                            <router-link :disabled="current.estado != 'A'" class="dropdown-item text-success" :to="{
                              name: 'cxp-abono-editar',
                              params: { id: abono.abono_e.id },
                            }" target="_blank">
                              <i class="fas fa-external-link-alt"></i> &nbsp; Ir a abono
                            </router-link>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <hr />
                <div style="display: flex; justify-content: flex-end">
                  <table style="background-color: #a7d688">
                    <tr>
                      <td colspan="1" class="text-center">
                        <h6 style="font-size: 15px" class="text-dark">TOTAL ABONO:</h6>
                      </td>
                      <td colspan="1" class="text-right">
                        <h6 style="font-size: 15px" class="font-weight-bold text-dark">
                          Q{{ current.total_aplicado }}
                        </h6>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="element-balances">
              <div class="col-12">
                <div class="row"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-4" style="
            padding-right: 10px;
            padding-left: 1px;
            position: fixed;
            right: 1vw;
            width: 23vw;
            top: 5.3vw;
          ">
          <!--------------------START - PANEl -------------------->
          <div class="content-panel compact panel panel-hover" style="padding-top: 10px">
            <div class="row">
              <div style="padding: 3px; height: 22px" class="badge col-12" :class="{
                'badge-primary': current.estado == 'A',
                'badge-warning': current.estado == 'B',
                'badge-danger': current.estado == '9',
              }">
                <span class="text-uppercase" v-if="current.estado_str">
                  {{ current.estado_str }}</span>
                <span v-if="!current.estado_str">En Proceso</span>
                &nbsp;
                <i class="os-icon os-icon-ui-09"></i>
              </div>
              <hr>
              <div class="col-sm-12">
                <ProveedoresSelectComponent :current="current" style="font-size: 11px" />
              </div>
              <div class="col-sm-6">
                <label v-bind:class="{
                  'text-danger':
                    current.errors.tipo_cargo && current.errors.tipo_cargo.length > 0,
                }">Tipo cargo</label>
                <select class="form-control form-control-sm text-lowercase" autofocus="autofocus"
                  v-model="current.tipo_cargo" :disabled="current.estado != 'A'">
                  <option v-for="(c, key) in tiposcargos" :value="c.id" :key="key">
                    {{ c.nombre }}
                  </option>
                </select>
                <small v-if="current.errors && current.errors.tipo_cargo" class="form-text text-danger">{{
                  current.errors.tipo_cargo[0] }}</small>
              </div>
              <div class="col-sm-6">
                <label>Forma pago</label>
                <select class="form-control form-control-sm" autofocus="autofocus" v-model="current.forma_pago"
                  :disabled="current.estado != 'A'">
                  <option value="CON" selected>contado</option>
                  <option value="CRE">credito</option>
                  <option value="NC">NC</option>
                </select>
                <small v-if="current.errors && current.errors.forma_pago" class="form-text text-danger">{{
                  current.errors.forma_pago[0] }}</small>
              </div>
              <div class="col-sm-6">
                <label>Origen</label>
                <select class="form-control" autofocus="autofocus" v-model="current.local_importado"
                  :disabled="current.estado != 'A'">
                  <option value="L">local</option>
                  <option value="E">import</option>
                </select>
                <small v-if="current.errors && current.errors.local_importado" class="form-text text-danger">{{
                  current.errors.local_importado[0] }}</small>
              </div>
              <div class="col-sm-6">
                <label>Tipo</label>
                <select class="form-control" autofocus="autofocus" v-model="current.bien_servicio"
                  :disabled="current.estado != 'A'">
                  <option value="B">bien</option>
                  <option value="S">servicio</option>
                </select>
                <small v-if="current.errors && current.errors.bien_servicio" class="form-text text-danger">{{
                  current.errors.bien_servicio[0] }}</small>
              </div>
              <div class="col-12">
                <label v-bind:class="{
                  'text-danger':
                    current.errors.referencia && current.errors.referencia.length > 0,
                }">Referencia</label>
                <input v-model="current.referencia" class="form-control form-control-sm" placeholder="Referencia"
                  style="font-size: 12px" :disabled="current.estado != 'A'" v-bind:class="{
                    'is-invalid':
                      current.errors.referencia && current.errors.referencia.length > 0,
                  }" type="text" />
                <small v-if="current.errors && current.errors.referencia" class="form-text text-danger">{{
                  current.errors.referencia[0] }}</small>
              </div>
              <div class="col-12">
                <label v-bind:class="{
                  'text-danger':
                    current.errors.descripcion && current.errors.descripcion.length > 0,
                }">Observaciones</label>
                <textarea v-model="current.descripcion" class="form-control form-control-sm" placeholder="Observaciones"
                  :disabled="current.estado != 'A'" style="font-size: 12px; max-height: 55px" v-bind:class="{
                    'is-invalid':
                      current.errors.descripcion && current.errors.descripcion.length > 0,
                  }" type="text">
                </textarea>
                <small v-if="current.errors && current.errors.descripcion" class="form-text text-danger">{{
                  current.errors.descripcion[0] }}</small>
              </div>
              <div class="col-6">
                <br />
                <label>Total cargo</label>
                <div class="input-group input-group-md">
                  <div class="input-group-prepend" style="height: 30px">
                    <div style="background-color: #9ad473; padding: 6px" class="input-group-text">
                      Q
                    </div>
                  </div>
                  <input class="form-control form-control-sm text-right" style="font-size: 13px; height: 30px"
                    :disabled="current.estado != 'A'" v-model="current.valor_total" placeholder="Precio" type="text"
                    @input="formatNumber()" />
                  <small v-if="current.errors && current.errors.valor_total" class="form-text text-danger">{{
                    current.errors.valor_total[0] }}</small>
                </div>
              </div>
              <div class="col-6">
                <br />
                <label>Pend. de abonar</label>
                <div class="input-group input-group-md">
                  <div class="input-group-prepend" style="height: 30px">
                    <div style="background-color: #9ad473; padding: 6px" class="input-group-text">
                      Q
                    </div>
                  </div>
                  <input class="form-control form-control-sm text-right" style="font-size: 13px; height: 30px"
                    :disabled="true" v-model="current.total_pendiente" placeholder="Precio" type="text" />
                </div>
              </div>
              <div class="col-12">
                <br />
                <button class="btn btn-primary btn-block" @click="guardar()" :disabled="current.estado != 'A'">
                  <i class="fas fa-save"></i> Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <!-- START - Resumen Facturas Table-->
        <div class="element-wrapper">
          <AggFacturaPorServicioComponent @refreshCargo="refreshCurrent()" :current_="current" />
          <AggPolizaContableComponent @refreshCargo="refreshCurrent()" :current_="current" />
          <AggRetencionesComponent @refreshCargo="refreshCurrent()" :current_="current"
            :current_cargod="current_cargod" />
          <br />
        </div>
        <!-------------------- END - Sidebar -------------------->
      </div>
    </div>
    <div aria-hidden="true" style="backdrop-filter: blur(8px)" class="onboarding-modal modal fade animated"
      id="modificarFacturas" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center" style="width: 80%; max-width: 80%">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <h3 class="text-success font-weight-bold">
                MODIFICAR FACTURA DETALLE&nbsp;&nbsp;
                <i class="fas fa-edit fa-2x"></i>
              </h3>
              <hr />
              <div class="col-12">
                <div class="row">
                  <div class="col-4 text-left text-dark">
                    <label>Serie Factura</label>
                    <input placeholder="Serie Factura" v-model="current_detalle.serie" class="form-control" type="text" />
                    <small class="text-danger" v-if="errors && errors.serie">{{
                      errors.serie[0]
                    }}</small>
                  </div>
                  <div class="col-4 text-left text-dark">
                    <label>Documento</label>
                    <input class="form-control" placeholder="# Documento" type="text"
                      v-model="current_detalle.documento" />
                    <small class="text-danger" v-if="errors && errors.documento">{{
                      errors.documento[0]
                    }}</small>
                  </div>
                  <div class="col-4 text-left text-dark">
                    <label>Fecha de Documento</label>
                    <input v-model="current_detalle.fecha_documento" class="form-control" type="date" />
                    <small class="text-danger" v-if="errors && errors.fecha_documento">{{
                      errors.fecha_documento[0]
                    }}</small>
                  </div>
                  <div class="col-4 text-left text-dark">
                    <label>Total</label>
                    <input v-model="current_detalle.valor_total" class="form-control" type="number" placeholder="Q 0.00"
                      @change="calcularImpuesto()" />
                    <small class="text-danger" v-if="errors && errors.valor_total">{{
                      errors.valor_total[0]
                    }}</small>
                  </div>
                  <div class="col-4 text-left text-dark">
                    <label>Total IVA</label>
                    <input v-model="current_detalle.valor_iva" class="form-control" type="number" placeholder="Q 0.00" />
                    <small class="text-danger" v-if="errors && errors.valor_iva">{{
                      errors.valor_iva[0]
                    }}</small>
                  </div>
                  <div class="col-4 text-left text-dark">
                    <label>NIT</label>
                    <input v-model="current_detalle.nit" class="form-control" type="text" placeholder="cliente NIT" />
                    <small class="text-danger" v-if="errors && errors.nit">{{
                      errors.nit[0]
                    }}</small>
                  </div>
                  <div class="col-12 text-left text-dark">
                    <label>Descripción del servicio</label>
                    <textarea v-model="current_detalle.observaciones" class="form-control" style="font-size: 20px"
                      placeholder="Descripción del servicio" rows="3"></textarea>
                    <smalls class="text-danger" v-if="errors && errors.observaciones">{{ errors.observaciones[0] }}
                    </smalls>
                  </div>
                </div>
                <br />
                <div>
                  <button @click="UpdateFactura()" class="btn btn-lg btn-primary btn-block">
                    Guardar cambios <i class="fas fa-save"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- aqui inicia el modal de modificar el detalle de facturas -->
    <div aria-hidden="true" class="modal fade" id="modalOpciones" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content color-scheme-dark">
          <div class="modal-body">
            <button aria-label="Close" class="close text-light" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>

            <button class="btn btn-sm btn-light btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
              :disabled="!(current.estado != '9')" @click="anular()">
              <div class="activity-avatar">
                <i class="fas fa-exclamation-circle fa-1x"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Anular operación</span>
              </div>
            </button>
            <button class="btn btn-sm btn-light btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
              :disabled="!(current.estado == 'B')" @click="abrir()">
              <div class="activity-avatar">
                <i class="fa fa-unlock fa-1x"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Abrir operación</span>
              </div>
            </button>
            <button class="btn btn-sm btn-light btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
              :disabled="current.estado == 'A'">
              <div class="activity-avatar">
                <i class="fa fa-print fa-1x"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Imprimir</span>
              </div>
            </button>
            <button class="btn btn-sm btn-primary btn-block" style="margin-top: 0.14rem; padding: 0.4rem"
              :disabled="!(current.estado == 'A')" @click="cerrar()">
              <div class="activity-avatar">
                <i class="fa fa-lock fa-1x text-dark"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold text-dark">Cerrar operación</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- aqui termina el modal de opciones -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Notifications from "@/notifications/notifications";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import CargoAplicacionAbonoComponent from "@/components/cxp/cargo/CargoAplicacionAbonoComponent";
import CargoDComponent from "@/components/cxp/cargo/CargoDComponent";
import AggFacturaPorServicioComponent from "@/components/cxp/cargo/AggFacturaPorServicioComponent";
import AggPolizaContableComponent from "@/components/cxp/cargo/AggPolizaContableComponent";
import AggRetencionesComponent from "@/components/cxp/cargo/AggRetencionesComponent";
import CuentaContableSelectComponent from "@/components/commons/CuentaContableSelectComponent";
import CentroCostoSelectComponent from "@/components/commons/CentroCostoSelectComponent";
import AggPagoPorCargoComponent from "@/components/cxp/cargo/AggPagoPorCargoComponent";

export default {
  watch: {
    current: {
      handler: function (newValue) {
        this.current.valor_total = newValue.valor_total
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.current.total_pendiente = newValue.total_pendiente
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      deep: true,
    },
  },

  components: {
    ProveedoresSelectComponent,
    CargoAplicacionAbonoComponent,
    CargoDComponent,
    AggFacturaPorServicioComponent,
    AggPolizaContableComponent,
    AggRetencionesComponent,
    CuentaContableSelectComponent,
    CentroCostoSelectComponent,
    AggPagoPorCargoComponent,
  },
  data() {
    return {
      detail: "",
      currentContable: {},
      apl_current: {
        tipo_abono: null,
        abono_e: null,
        valor_total: null,
        errors: {
          tipo_abono: null,
          abono_e: null,
          valor_total: null,
        },
      },
      abonos: [],
      current: {
        id: null,
        bien_servicio_str: "B",
        local_importado_str: "L",
        total: null,
        total_aplicado: null,
        total_pendiente: 0,
        cargod_set: [],
        aplicacionabonocargo_set: null,
        cargocontab_set: null,
        numero: null,
        fecha_creacion: null,
        fecha: null,
        referencia: null,
        fecha_documento: null,
        fecha_vencimiento: null,
        fecha_pago: null,
        fecha_iva: null,
        forma_pago: "CON",
        descripcion: null,
        factura_especial: null,
        estatus_contab: null,
        bien_servicio: null,
        local_importado: null,
        valor_total: 0,
        valor_impuesto: 0,
        estado: "A",
        tipo_cargo: "FACT",
        proveedor: null,
        errors: {
          id: null,
          estado_str: null,
          total_aplicado: null,
          total_pendiente: null,
          documento: null,
          fecha_creacion: null,
          fecha_documento: null,
          fecha_vencimiento: null,
          valor: null,
          descripcion: null,
          estatus_contab: null,
          conciliado: null,
          fecha_conciliacion: null,
          estado: null,
          beneficiario: null,
          es_negociable: null,
          tipo_abono: null,
          abono_serie: null,
          proveedor: null,
        },
      },
      current_detalle: {},
      current_cargod: {},
      errors: {
        id: null,
        estado_str: null,
        total_aplicado: null,
        total_pendiente: null,
        documento: null,
        fecha_creacion: null,
        fecha_documento: null,
        fecha_vencimiento: null,
        valor: null,
        descripcion: null,
        estatus_contab: null,
        conciliado: null,
        fecha_conciliacion: null,
        estado: null,
        beneficiario: null,
        es_negociable: null,
        tipo_abono: null,
        abono_serie: null,
        proveedor: null,
      },
      errors: null,
      index_: null,
      abonoseries: [],
      tiposcargos: [],
      mostrar_cuadro: false,
      current_fact: {},
      detalle_: null,
      detalle_facts_service: null,
    };
  },
  computed: {
    ...mapGetters({
      fecha_actual: "commons/fecha_actual",
      proveedor: "catalogos/proveedores",
      tipos_abonos: "cxpabonos/tipoabono",
    }),
  },
  mounted() {
    let self = this;
    if (self.$route.params.id) {
      self.refreshCurrent();
    } else {
      self.$store.dispatch("commons/fecha_actual").then((response) => {
        self.current.fecha_documento = self.fecha_actual;
        self.current.fecha_vencimiento = self.current.fecha_documento;

        self.current.fecha_documento = self.customFormatterInverted(
          self.current.fecha_documento
        );
        self.current.fecha_pago = self.customFormatterInverted(self.current.fecha_pago);
        self.current.fecha = self.current.fecha_documento;
      });
    }
    self.refreshTiposCargos();
    self.refreshProveedor();
    self.refreshTipoAbono();
  },
  methods: {
    formatNumber() {
      if (!this.current.valor_total) {
        return;
      }
      this.current.valor_total = this.current.valor_total.toString().replace(/,/g, "");
      if (this.current.valor_total.includes(".")) {
        this.current.valor_total = this.current.valor_total.replace(/\./g, "");
        this.current.valor_total = this.current.valor_total
          .toString()
          .replace(/(\d{2})$/, ".$1");
      }
      this.current.valor_total = this.current.valor_total
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    generarAutoContabilizacion() {
      let self = this;
      Notifications.alert.confirm(
        "Generar la contabilizacón automáticamente",
        "¿Esta seguro(a)?",
        "",
        function () {
          DynamicService.postAction(
            "cxp",
            "cargos",
            self.current.id,
            "generar_contab_auto"
          )
            .then((res) => {
              Notifications.alert.success(
                "Generar la contabilizacón automáticamente",
                "Generado correctamente"
              );
              self.refreshCurrent();
            })
            .catch((err) => {
              self.errors = err.response.data;
              if (err.response.data.detail) {
                Notifications.alert.error("Modificar factura", err.response.data.detail);
              }
            });
        }
      );
    },
    eliminarRetencion(det) {
      DynamicService.postAction(
        "cxp",
        "cargos",
        this.current.id,
        "eliminar_retencion",
        det
      )
        .then((response) => {
          Notifications.alert.success("Eliminar Retención", "Realizado Exitosamente");
          this.refreshCurrent();
        })
        .catch((errors) => {
          Notifications.alert.error("Eliminar Retención", errors.response.data.detail);
        });
    },
    eliminarContabilicacion(det) {
      DynamicService.postAction(
        "cxp",
        "cargos",
        this.current.id,
        "eliminar_contabilizacion",
        det
      )
        .then((response) => {
          Notifications.alert.success(
            "Eliminar Contabilización",
            "Realizado Exitosamente"
          );
          this.refreshCurrent();
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Eliminar Contabilización",
            errors.response.data.detail
          );
        });
    },
    UpdateFactura() {
      let self = this;
      Notifications.alert.confirm(
        "Modificar factura",
        "¿Esta seguro(a)?",
        "",
        function () {
          if (self.current_detalle.fecha_documento) {
            self.current_detalle.fecha_documento = moment(
              self.current_detalle.fecha_documento
            ).format("YYYY-MM-DD");
          }
          DynamicService.postAction(
            "cxp",
            "cargos",
            self.current.id,
            "agregar_modificar_factura_servicio",
            self.current_detalle
          )
            .then((res) => {
              Notifications.alert.success("Modificar factura", "Generado correctamente");
              $("#modificarFacturas").modal("hide");
              self.refreshCurrent();
            })
            .catch((err) => {
              self.errors = err.response.data;
              if (err.response.data.detail) {
                Notifications.alert.error("Modificar factura", err.response.data.detail);
              }
            });
        }
      );
    },
    calcularImpuesto() {
      let self = this;
      DynamicService.getAction(
        "cxp",
        "cargos",
        self.current.id,
        "calcular_iva_facturas_servicios",
        self.current_detalle
      ).then((res) => {
        self.current_detalle.valor_iva = res.data.valor_iva;
      });
    },
    modificarFacturas(detalle) {
      let self = this;
      self.current_detalle = detalle;
      self.current_detalle.fecha_documento = self.customFormatterInverted(
        detalle.fecha_documento
      );
      $("#modificarFacturas").modal("show");
    },
    AbrirModalretenciones(detalle) {
      let self = this;
      self.current_cargod = detalle;
      $("#aggrentenciones").modal("show");
    },
    eliminarFacturaServicio(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "¡Importante!",
        "¿Desea eliminar la factura seleccionada?",
        "",
        function () {
          DynamicService.postAction(
            "cxp",
            "cargos",
            self.current.id,
            "eliminar_detalle",
            {
              id: detalle.id,
            }
          )
            .then((res) => {
              Notifications.toast.success("Eliminar factura", "Realizado correctamente");
              self.refreshCurrent();
              self.refreshAbonos();
            })
            .catch((error) => {
              console.log(error.response.data);
              if (error.response.data.detail) {
                Notifications.alert.error("Eliminar factura", error.response.data.detail);
              }
              self.refreshCurrent();
              self.refreshAbonos();
            });
        }
      );
    },
    eliminarAbonoACargo(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "¡Importante!",
        "¿Desea eliminar el abono seleccionado?",
        "",
        function () {
          DynamicService.postAction(
            "cxp",
            "cargos",
            self.current.id,
            "eliminar_abono_aplicado",
            {
              id: detalle.id,
            }
          )
            .then((res) => {
              Notifications.toast.success("Eliminar abono", "Realizado correctamente");
              self.refreshCurrent();
              self.refreshAbonos();
            })
            .catch((error) => {
              console.log(error.response.data);
              self.refreshCurrent();
              self.refreshAbonos();
            });
        }
      );
    },
    refreshAbonos() {
      let self = this;
      let params = {
        con_saldo_pendiente: "True",
        tipo_abono: self.apl_current.tipo_abono,
        proveedor: self.current.proveedor.codigo,
      };
      DynamicService.fetch("cxp", "abonos", params).then((res) => {
        self.abonos = res.data;
      });
    },
    refreshTipoAbono() {
      let self = this;
      self.$store.dispatch("cxpabonos/tipoabono", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    mostrarDetalle(index, detalle) {
      let self = this;
      if (self.detalle_ == detalle || self.detalle_facts_service == detalle) {
        self.detalle_ = null;
        self.detalle_facts_service = null;
        return;
      }
      if (detalle.bien_servicio == "S") {
        self.detalle_facts_service = detalle;
        self.detalle_ = null;
        return;
      }
      if (detalle.bien_servicio == "B") {
        self.detalle_ = detalle;
        self.detalle_facts_service = null;
        return;
      }
    },
    customFormatterInverted(date) {
      if (date == null) {
        return "";
      }
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).add("days").format("YYYY-MM-DD");
    },
    refreshCurrent() {
      let self = this;

      if (this.$route.params.id) {
        DynamicService.getById("cxp", "cargos", this.$route.params.id).then(
          (response) => {
            self.current = Object.assign(self.current, response.data);
            self.current.proveedor = self.current.proveedor_obj;
            self.current.valor_temp = self.current.valor_total;
            self.current.fecha_documento = self.customFormatterInverted(
              self.current.fecha_documento
            );
            self.current.fecha_vencimiento = self.customFormatterInverted(
              self.current.fecha_vencimiento
            );
            self.current.fecha_conciliacion = self.customFormatterInverted(
              self.current.fecha_conciliacion
            );
            self.current.fecha_iva = self.customFormatterInverted(self.current.fecha_iva);
            self.current.fecha = self.customFormatterInverted(self.current.fecha);
            self.current.fecha_pago = self.customFormatterInverted(
              self.current.fecha_pago
            );
          }
        );
      }
    },
    refreshTiposCargos() {
      let self = this;
      DynamicService.fetch("cxp", "tipo-cargo", {
        quitar_paginacion: true,
      }).then((res) => {
        self.tiposcargos = res.data;
        if (self.tiposcargos.length != 0) {
          self.current.tipo_cargo = self.tiposcargos[0].id;
        }
      });
    },
    changeAbonoSerie() {
      let self = this;
      let obj = self.abonoseries.filter(function (elem) {
        if (elem.serie == self.current.abono_serie) return elem;
      });
      if (obj.length == 1) {
        self.current.abono_serie_obj = obj[0];
      }
      console.log(self.current.abono_serie_obj);
    },
    refreshProveedor() {
      let self = this;
      self.$store.dispatch("catalogos/proveedores", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    guardar() {
      let self = this;
      var current = Object.assign({}, self.current);
      if (this.$route.params.id) {
        current.pk = this.$route.params.id;
      }
      if (current.proveedor) {
        current.proveedor = current.proveedor.codigo;
      }
      if (current.id == null) {
        current.documento = 0;
      }
      if (current.fecha_documento) {
        current.fecha_documento = moment(current.fecha_documento).format("DD/MM/YYYY");
      }
      if (current.fecha_vencimiento) {
        current.fecha_vencimiento = moment(current.fecha_vencimiento).format(
          "DD/MM/YYYY"
        );
      }
      if (current.fecha_iva) {
        current.fecha_iva = moment(current.fecha_iva).format("DD/MM/YYYY");
      }
      if (current.fecha) {
        current.fecha = moment(current.fecha).format("DD/MM/YYYY");
      }
      if (current.fecha_conciliacion) {
        current.fecha_conciliacion = moment(current.fecha_conciliacion).format(
          "DD/MM/YYYY"
        );
      }
      if (current.fecha_pago) {
        current.fecha_pago = moment(current.fecha_pago).format("DD/MM/YYYY");
      }
      if (current.valor_total) {
        current.valor_total = current.valor_total.replace(/,/g, "");
      }
      if (current.id == null) {
        delete current.id;
      }
      DynamicService.save("cxp", "cargos", current)
        .then((res) => {
          self.current.errors = [];
          Notifications.alert.success("CXP - Cargos", "Se ha guardado la Información.");
          self.$router.push({
            name: "cxp-cargo-editar",
            params: { id: res.data.id },
          });
          self.refreshCurrent();
        })
        .catch((error) => {
          console.log(error.response.data);
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
          });
        });
    },
    showModal(e) {
      e.preventDefault();
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Cargos",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          DynamicService.postAction("cxp", "cargos", self.current.id, "abrir")
            .then((response) => {
              Notifications.alert.success(
                "Cargos",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Cargos",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          DynamicService.postAction("cxp", "cargos", self.current.id, "cerrar")
            .then((response) => {
              Notifications.alert.success("Cargos", "Se ha cerrado la transaccion.");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Cerrar Transaccion", error.response.data.detail);
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Cargos",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          DynamicService.postAction("cxp", "cargos", self.current.id, "cerrar")
            .then((response) => {
              Notifications.alert.success("Cargos", "Se ha cerrado la transaccion.");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Cerrar Transaccion", error.response.data.detail);
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Cargos",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          DynamicService.postAction("cxp", "cargos", self.current.id, "anular")
            .then((response) => {
              Notifications.alert.success("Cargos", "Se ha anulado la transaccion.");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Anular Transaccion", error.response.data.detail);
            });
        }
      );
    },
    Imprimir_cxpcargo() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=cxp/cargos/cxp_cargo_reporte.jrxml&id=${self.id}`
      );
    },
  },
};
</script>
